/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CompetitionEntry model module.
 * @module model/CompetitionEntry
 * @version v1
 */
class CompetitionEntry {
    /**
     * Constructs a new <code>CompetitionEntry</code>.
     * @alias module:model/CompetitionEntry
     * @param communicationTypeId {Number} 
     * @param totalPlays {Number} 
     */
    constructor(communicationTypeId, totalPlays) { 
        
        CompetitionEntry.initialize(this, communicationTypeId, totalPlays);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, communicationTypeId, totalPlays) { 
        obj['CommunicationTypeId'] = communicationTypeId;
        obj['TotalPlays'] = totalPlays;
    }

    /**
     * Constructs a <code>CompetitionEntry</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompetitionEntry} obj Optional instance to populate.
     * @return {module:model/CompetitionEntry} The populated <code>CompetitionEntry</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompetitionEntry();

            if (data.hasOwnProperty('CommunicationTypeId')) {
                obj['CommunicationTypeId'] = ApiClient.convertToType(data['CommunicationTypeId'], 'Number');
            }
            if (data.hasOwnProperty('TotalPlays')) {
                obj['TotalPlays'] = ApiClient.convertToType(data['TotalPlays'], 'Number');
            }
            if (data.hasOwnProperty('AnswerId')) {
                obj['AnswerId'] = ApiClient.convertToType(data['AnswerId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CompetitionEntry</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CompetitionEntry</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CompetitionEntry.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CompetitionEntry.RequiredProperties = ["CommunicationTypeId", "TotalPlays"];

/**
 * @member {Number} CommunicationTypeId
 */
CompetitionEntry.prototype['CommunicationTypeId'] = undefined;

/**
 * @member {Number} TotalPlays
 */
CompetitionEntry.prototype['TotalPlays'] = undefined;

/**
 * @member {Number} AnswerId
 */
CompetitionEntry.prototype['AnswerId'] = undefined;






export default CompetitionEntry;

